var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "auto",
    viewBox: "0 0 698.704 645.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22657",
    "data-name": "Groupe 22657",
    transform: "translate(-531 -229.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4288",
    "data-name": "Trac\\xE9 4288",
    d: "M0,0H678.625V1.843H0Z",
    transform: "translate(531 873.33)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21916",
    "data-name": "Groupe 21916",
    transform: "translate(617 618.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4236",
    "data-name": "Trac\\xE9 4236",
    d: "M811.175,1113.926a87.615,87.615,0,0,0-46.449-45.378c-21.351-8.647-45.867-5.5-68.357-8.4-19.532-2.515-33.625-11.235-45.287-26.738-11.174-14.854-21.194-31.3-39.465-38.176-14.437-5.429-30.85-3.924-45.2,1.733-26.44,10.425-46.409,32.591-63.227,54.674-15.355,20.161-27.88,42.238-56.282,42.959-28.42.721-55.477-15.491-84.093-11.2-37.82,5.678-69.317,37.162-75.917,74.644-6.186,35.129,9.336,69.2,36,89.217H781.247C814.848,1211.625,832.479,1162.383,811.175,1113.926Z",
    transform: "translate(-285.545 -991.86)",
    fill: "#ecf4fd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4240",
    "data-name": "Trac\\xE9 4240",
    d: "M859.673,829.171c8.03,8.2,11.628,22.027,7.2,34.771-4.287,12.34-13.683,22.561-24.974,29.132-9.083,5.287-20.933,8.2-29.867,2.667-6.676-4.137-10.138-12.254-10.33-20.105s2.448-15.5,5.712-22.647c4.6-10.07,10.792-19.835,20.015-25.959C840.143,818.588,851.955,821.284,859.673,829.171Z",
    transform: "translate(35.071 -279.883)",
    fill: "#ecf4fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21919",
    "data-name": "Groupe 21919",
    transform: "translate(934.115 397.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4243",
    "data-name": "Trac\\xE9 4243",
    d: "M1231.222,475.665a102.755,102.755,0,0,0-22.717-39.474q-16.293-18.023-44.44-29.78t-71.528-11.768A279.842,279.842,0,0,0,1022,403.976q-35.963,9.367-62.411,26.669l22.96,63.036-12.305,9.969,17.847,5.245q26.426-13.831,48.149-20.087a166.478,166.478,0,0,1,46.118-6.222q24.406,0,36.956,11.768,12.55,11.8,12.539,28.405a54.505,54.505,0,0,1-12.871,35.664q-12.915,15.589-28.5,31.516-10.829,11.058-21.017,22.837a163.951,163.951,0,0,0-17.97,25.294,137.528,137.528,0,0,0-12.54,29.081,119.368,119.368,0,0,0-4.746,34.966c0,4.17.088,9.13.331,14.9.041,1.065.1,2.1.16,3.127H1017.83l18.411,12.45h89.521a59.484,59.484,0,0,1-.684-9.693v-8.319a60.135,60.135,0,0,1,4.747-23.2,119.983,119.983,0,0,1,11.877-21.822,161.171,161.171,0,0,1,15.939-19.726q8.809-9.367,16.955-17.674,10.829-11.057,22.364-23.536a184.973,184.973,0,0,0,20.354-26.309,147.793,147.793,0,0,0,14.571-30.141,106.1,106.1,0,0,0,5.784-35.664A142.628,142.628,0,0,0,1231.222,475.665Z",
    transform: "translate(-942.08 -393.078)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4244",
    "data-name": "Trac\\xE9 4244",
    d: "M1033.419,475.509a167.778,167.778,0,0,0-45.577,6.022q-21.469,6.054-47.584,19.44l-28.166-75.729q26.148-16.756,61.678-25.81a282.074,282.074,0,0,1,69.707-9.033q42.871,0,70.689,11.389t43.919,28.821q16.068,17.443,22.45,38.2a135.407,135.407,0,0,1,6.371,39.533,100.757,100.757,0,0,1-5.716,34.515,141.816,141.816,0,0,1-14.4,29.17,179.6,179.6,0,0,1-20.116,25.461q-11.389,12.076-22.1,22.778-8.051,8.051-16.756,17.105a156.642,156.642,0,0,0-15.752,19.09,115.372,115.372,0,0,0-11.738,21.12,57.153,57.153,0,0,0-4.691,22.45v8.051a56.382,56.382,0,0,0,.677,9.382h-88.47a93.776,93.776,0,0,1-1.68-15.076c-.24-5.585-.327-10.385-.327-14.421a113.284,113.284,0,0,1,4.691-33.839,131.666,131.666,0,0,1,12.393-28.145,158.7,158.7,0,0,1,17.759-24.479q10.047-11.389,20.77-22.1,15.414-15.414,28.167-30.5a52.092,52.092,0,0,0,12.72-34.515q0-16.1-12.392-27.49T1033.419,475.509Z",
    transform: "translate(-912.092 -390.399)",
    fill: "#a02528"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21920",
    "data-name": "Groupe 21920",
    transform: "translate(1004.17 772.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4245",
    "data-name": "Trac\\xE9 4245",
    d: "M1251.851,1461.4q0,24.21-15.675,37.379-15.675,13.2-35.447,13.187a53.529,53.529,0,0,1-35.465-13.187q-15.648-13.179-15.657-37.379,0-24.183,15.657-37.379c16.085-13.575,39.882-16.6,58.715-7.072C1240.691,1425.405,1251.851,1442.573,1251.851,1461.4Z",
    transform: "translate(-1132.096 -1410.836)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4246",
    "data-name": "Trac\\xE9 4246",
    d: "M1204.351,1460.414q0,24.21-15.675,37.379Q1173,1511,1153.229,1510.981a53.528,53.528,0,0,1-35.465-13.187q-15.648-13.179-15.657-37.379,0-24.183,15.657-37.379,15.675-13.178,35.465-13.187t35.447,13.187Q1204.351,1436.241,1204.351,1460.414Z",
    transform: "translate(-1102.108 -1409.848)",
    fill: "#a02528"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 28.015,
    cy: 28.015,
    rx: 28.015,
    ry: 28.015,
    transform: "matrix(0.184, -0.983, 0.983, 0.184, 729.995, 562.594)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 15.757,
    cy: 15.869,
    rx: 15.757,
    ry: 15.869,
    transform: "translate(769.511 607.645) rotate(-79.386)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 116.958,
    cy: 116.958,
    r: 116.958,
    transform: "translate(531 395.105) rotate(-45)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22656",
    "data-name": "Groupe 22656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21927",
    "data-name": "Groupe 21927",
    transform: "translate(692.485 778.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21925",
    "data-name": "Groupe 21925",
    transform: "translate(27.39 62.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4247",
    "data-name": "Trac\\xE9 4247",
    d: "M496.195,1607.693l3.547,13.673a7.834,7.834,0,0,0,8.187,5.716c11.629-.79,35.791-3.639,49.659-13.86l-3.942-19.706c-19.067-1.077-36.9-.017-52.339,5.181A7.552,7.552,0,0,0,496.195,1607.693Z",
    transform: "translate(-495.961 -1593.136)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4248",
    "data-name": "Trac\\xE9 4248",
    d: "M547.931,1631.366a.461.461,0,0,1-.443-.337l-4.762-17.051a.461.461,0,0,1,.888-.248l4.762,17.051a.46.46,0,0,1-.444.585Z",
    transform: "translate(-525.473 -1605.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4249",
    "data-name": "Trac\\xE9 4249",
    d: "M575.847,1625.115a.462.462,0,0,1-.444-.337l-4.762-17.051a.461.461,0,0,1,.888-.247l4.762,17.051a.462.462,0,0,1-.32.568A.477.477,0,0,1,575.847,1625.115Z",
    transform: "translate(-543.098 -1601.978)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4250",
    "data-name": "Trac\\xE9 4250",
    d: "M541.326,1427.317l-44.316,13.152,32.911,45.094,47.249,3.758,65.171-27.557L617.576,1424.5Z",
    transform: "translate(-469.233 -1424.498)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4251",
    "data-name": "Trac\\xE9 4251",
    d: "M674.638,1439.1c97.322-28.81,112.963,57.2-38.885,72.86-5.364-6.035-11.631-16.507-14.12-25.261l80.188-37.057Z",
    transform: "translate(-547.91 -1430.019)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4252",
    "data-name": "Trac\\xE9 4252",
    d: "M734.571,1608.908a42.1,42.1,0,0,1-8.913-4.337l-15.641,4.906,3.585,17.015,16.248,3.3C734.8,1620.74,735.088,1613.306,734.571,1608.908Z",
    transform: "translate(-603.709 -1538.182)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4253",
    "data-name": "Trac\\xE9 4253",
    d: "M621.386,1509.373l-.695-1.2c16.729-9.722,59.579-33.079,96.087-39.968l.256,1.359C680.737,1476.417,638.053,1499.686,621.386,1509.373Z",
    transform: "translate(-547.315 -1452.094)",
    fill: "#273f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4254",
    "data-name": "Trac\\xE9 4254",
    d: "M493.76,1428.3c-90.587-17.223-114.048,69.833,37.8,85.491a55.158,55.158,0,0,0,12.056-21.921,691.357,691.357,0,0,0-77.987-44.572Z",
    transform: "translate(-421.667 -1425.481)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4255",
    "data-name": "Trac\\xE9 4255",
    d: "M601.7,1515.723c-4.309-2.743-8.8-5.642-13.553-8.712-23.863-15.407-50.91-32.87-73.89-42.828l.55-1.268c23.084,10,50.182,27.5,74.09,42.936,4.752,3.068,9.24,5.966,13.546,8.706Z",
    transform: "translate(-480.119 -1448.752)",
    fill: "#273f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4256",
    "data-name": "Trac\\xE9 4256",
    d: "M434.865,1526.947l-1.21-.668c3.4-6.156,8.847-10.308,16.188-12.341l.369,1.332C443.144,1517.227,438.124,1521.047,434.865,1526.947Z",
    transform: "translate(-429.235 -1480.964)",
    fill: "#273f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4257",
    "data-name": "Trac\\xE9 4257",
    d: "M923.49,1512.731c-3.259-5.9-8.279-9.719-15.347-11.677l.369-1.332c7.341,2.033,12.788,6.185,16.188,12.341Z",
    transform: "translate(-728.791 -1471.989)",
    fill: "#273f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4258",
    "data-name": "Trac\\xE9 4258",
    d: "M695,1617.449l-1.011-.943c7.246-7.761,11.7-15.954,13.606-25.047l1.353.284C706.987,1601.089,702.424,1609.5,695,1617.449Z",
    transform: "translate(-593.591 -1529.904)",
    fill: "#273f60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21926",
    "data-name": "Groupe 21926",
    transform: "translate(126.141 63.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4259",
    "data-name": "Trac\\xE9 4259",
    d: "M813.712,1598.777c-11.606-7.17-34.106,5.219-39.754,5.846a13.594,13.594,0,0,1-5.424-.778c.517,4.4.228,11.832-4.721,20.885l2.76.561s19.08,6.994,39.32,2.923C824.573,1624.455,822.836,1604.413,813.712,1598.777Z",
    transform: "translate(-763.812 -1596.55)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4260",
    "data-name": "Trac\\xE9 4260",
    d: "M851.909,1631.876a.468.468,0,0,1-.139-.021.461.461,0,0,1-.3-.578c1.379-4.366,1.98-12.955-2.013-18.724a.461.461,0,0,1,.758-.525c4.182,6.041,3.568,14.987,2.134,19.526A.462.462,0,0,1,851.909,1631.876Z",
    transform: "translate(-817.83 -1606.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4261",
    "data-name": "Trac\\xE9 4261",
    d: "M827.222,1636.564a.466.466,0,0,1-.139-.021.461.461,0,0,1-.3-.578c1.378-4.366,1.98-12.956-2.013-18.724a.461.461,0,1,1,.758-.524c4.182,6.041,3.568,14.987,2.134,19.526A.46.46,0,0,1,827.222,1636.564Z",
    transform: "translate(-802.244 -1609.156)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21935",
    "data-name": "Groupe 21935",
    transform: "translate(670.253 627.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21929",
    "data-name": "Groupe 21929",
    transform: "translate(51.359 0.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4262",
    "data-name": "Trac\\xE9 4262",
    d: "M527.611,1057.891s22.814-19.4,21.969-23.087c-.6-2.635-7.066,1.229-7.066,1.229s9.063-10.753,8.6-12.059c-.824-2.333-7.092,2.016-7.092,2.016s4.237-6.1,2.211-7.092-6.442,2.764-6.442,2.764,2.58-3.386,1.368-4.274-6.441,2.764-6.441,2.764,1.877-4.269-2.11-2.651-31.939,27.271-31.939,27.271Z",
    transform: "translate(-500.671 -1017.136)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21928",
    "data-name": "Groupe 21928",
    transform: "translate(25.675 2.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4263",
    "data-name": "Trac\\xE9 4263",
    d: "M580.912,1053.627a.46.46,0,0,1-.311-.121c-3.916-3.578-5.643-4.446-9.963-5.776a.461.461,0,1,1,.271-.88c4.476,1.377,6.264,2.276,10.314,5.976a.461.461,0,0,1-.311.8Z",
    transform: "translate(-570.312 -1038.438)",
    fill: "#bca4aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4264",
    "data-name": "Trac\\xE9 4264",
    d: "M579.628,1081.5a.472.472,0,0,1-.064,0,.461.461,0,0,1-.393-.52c.448-3.208,1.458-5.213,3.087-6.129,1.393-.783,3.2-.7,5.386.239a.461.461,0,1,1-.365.846c-1.9-.822-3.44-.917-4.569-.282-1.342.755-2.226,2.59-2.626,5.452A.461.461,0,0,1,579.628,1081.5Z",
    transform: "translate(-575.902 -1055.793)",
    fill: "#bca4aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4265",
    "data-name": "Trac\\xE9 4265",
    d: "M576.711,1030.387a.46.46,0,0,1-.316-.8l5.724-5.4a.461.461,0,1,1,.632.67l-5.725,5.4A.456.456,0,0,1,576.711,1030.387Z",
    transform: "translate(-574.061 -1024.07)",
    fill: "#bca4aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4266",
    "data-name": "Trac\\xE9 4266",
    d: "M591.086,1034.815a.461.461,0,0,1-.333-.78l5.5-5.729a.461.461,0,1,1,.665.638l-5.5,5.729A.461.461,0,0,1,591.086,1034.815Z",
    transform: "translate(-583.136 -1026.655)",
    fill: "#bca4aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4267",
    "data-name": "Trac\\xE9 4267",
    d: "M605.773,1045.453a.461.461,0,0,1-.337-.775l4.314-4.628a.461.461,0,1,1,.674.628l-4.314,4.628A.462.462,0,0,1,605.773,1045.453Z",
    transform: "translate(-592.409 -1034.066)",
    fill: "#bca4aa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21930",
    "data-name": "Groupe 21930",
    transform: "translate(0 23.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4268",
    "data-name": "Trac\\xE9 4268",
    d: "M648.88,1291.3l-83.413,3.226-9.217-76.039s27.925-26.486,38.668-36.24l18.137-.93C669.327,1206.893,660.112,1238.839,648.88,1291.3Z",
    transform: "translate(-484.4 -1143.315)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4269",
    "data-name": "Trac\\xE9 4269",
    d: "M710.329,1181.315s64.379,5.506,84.674,49.613c19.859,43.159-61.753,58.527-61.753,58.527Z",
    transform: "translate(-581.674 -1143.315)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4270",
    "data-name": "Trac\\xE9 4270",
    d: "M416.43,1125.7l26.6-32.374-24.878-15.077c-10.378,7.216-30.445,23.559-47.452,42.067a35.126,35.126,0,0,0-8.162,14.111,30.363,30.363,0,0,0-.781,13.248h0a25.577,25.577,0,0,0,22.6,21.413c10.135,1.187,48.85-1.843,80.187-11.06l9.217-35.573C469.032,1119.762,433.832,1119.3,416.43,1125.7Z",
    transform: "translate(-361.364 -1078.245)",
    fill: "#a02528"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21933",
    "data-name": "Groupe 21933",
    transform: "translate(82.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4275",
    "data-name": "Trac\\xE9 4275",
    d: "M686.45,1133.459l-.012,1.181-.187,18.334-.023,1.986a11.417,11.417,0,0,1-22.833-.012l-.222-22.658Z",
    transform: "translate(-634.648 -1089.023)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4276",
    "data-name": "Trac\\xE9 4276",
    d: "M701.326,1138.662,701.139,1157c-10.189-4.148-14.385-15.18-14.385-15.18Z",
    transform: "translate(-649.535 -1093.045)",
    fill: "#e3c9cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4277",
    "data-name": "Trac\\xE9 4277",
    d: "M686.437,1049.129c3.652,4.382,14.315,29.213,3.506,37.685-12.163,9.534-30.674-6.135-30.674-6.135l-2.483-28.921,16.067-4.236Z",
    transform: "translate(-630.615 -1035.506)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4278",
    "data-name": "Trac\\xE9 4278",
    d: "M603.786,1047.559s-35.638,18.587-6.58,72.167a14.6,14.6,0,0,0,19.071,6.528h0a14.455,14.455,0,0,0,6.339-20.187c-4.753-8.445-9.341-19.318-7.383-27.409Z",
    transform: "translate(-585.801 -1035.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 9.64,
    cy: 9.64,
    r: 9.64,
    transform: "translate(7.717 20.828) rotate(-45)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4279",
    "data-name": "Trac\\xE9 4279",
    d: "M645.377,1047.342c-1.042-6.015-1.676-10.139,4.4-13.239,0,0,21.423,3.9,25.513-4.187s-2.142-20.839-15.191-11.977c-33.4-6.525-37.88,24.734-27.753,35.153l10-1.534A3.639,3.639,0,0,0,645.377,1047.342Z",
    transform: "translate(-612.167 -1014.931)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21932",
    "data-name": "Groupe 21932",
    transform: "translate(43.102 21.44)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 1.424,
    cy: 1.424,
    r: 1.424,
    transform: "translate(5.271 9.564)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 1.424,
    cy: 1.424,
    r: 1.424,
    transform: "translate(14.911 4.817)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4280",
    "data-name": "Trac\\xE9 4280",
    d: "M739.027,1103.518a.4.4,0,0,1-.292-.681c.571-.6,1.2-1.447.934-2.059-.273-.636-1.428-.911-1.956-.911-1.136,0-1.682-2.021-1.78-2.427a.4.4,0,0,1,.784-.189c.208.854.677,1.81,1,1.81.544,0,2.207.257,2.7,1.4.35.816-.017,1.8-1.09,2.933A.4.4,0,0,1,739.027,1103.518Z",
    transform: "translate(-723.677 -1088.146)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4281",
    "data-name": "Trac\\xE9 4281",
    d: "M733.847,1126.4a.4.4,0,0,1-.225-.069,5.389,5.389,0,0,0-5.416-.276.4.4,0,0,1-.4-.7,6.13,6.13,0,0,1,6.27.308.4.4,0,0,1-.226.737Z",
    transform: "translate(-718.424 -1105.628)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4282",
    "data-name": "Trac\\xE9 4282",
    d: "M708.781,1085.018c.81,1.525-.6,1.831-2.256,2.71s-3.348,1.2-3.734.473.641-2.03,2.295-2.909S708.154,1083.837,708.781,1085.018Z",
    transform: "translate(-702.71 -1080.198)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4283",
    "data-name": "Trac\\xE9 4283",
    d: "M735.472,1075.153c.356,1.361,1.371.765,2.848.379s2.669-1.128,2.5-1.777-1.5-.862-2.981-.476S735.2,1074.1,735.472,1075.153Z",
    transform: "translate(-723.368 -1073.085)",
    fill: "#010344"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 5.687,
    cy: 6.463,
    rx: 5.687,
    ry: 6.463,
    transform: "matrix(0.611, -0.792, 0.792, 0.611, 18.685, 39.644)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4284",
    "data-name": "Trac\\xE9 4284",
    d: "M657.725,1118.641a.4.4,0,0,1-.4-.4,3.534,3.534,0,0,0-1.552-2.944,2.847,2.847,0,0,0-2.65-.353.4.4,0,0,1-.3-.747,3.649,3.649,0,0,1,3.4.43,4.337,4.337,0,0,1,1.909,3.613A.4.4,0,0,1,657.725,1118.641Z",
    transform: "translate(-627.95 -1077.444)",
    fill: "#102048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21934",
    "data-name": "Groupe 21934",
    transform: "translate(40.175 70.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    width: 21.437,
    height: 0.922,
    transform: "translate(0 15.741) rotate(-47.248)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4285",
    "data-name": "Trac\\xE9 4285",
    d: "M787.4,1355.985l-.268-.881c10.593-3.229,20.873-7.091,30.19-18.742l.72.575C808.565,1348.794,798.142,1352.713,787.4,1355.985Z",
    transform: "translate(-670.339 -1288.338)",
    fill: "#102048"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21938",
    "data-name": "Groupe 21938",
    transform: "translate(737.954 729.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21936",
    "data-name": "Groupe 21936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4286",
    "data-name": "Trac\\xE9 4286",
    d: "M640.979,1292.776H550.868a6.122,6.122,0,0,0-5.868,6.348v64.336a6.122,6.122,0,0,0,5.868,6.348h90.111a6.122,6.122,0,0,0,5.868-6.348v-64.336A6.122,6.122,0,0,0,640.979,1292.776Z",
    transform: "translate(-545 -1292.776)",
    fill: "#cde5f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21937",
    "data-name": "Groupe 21937",
    transform: "translate(43.704 32.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4287",
    "data-name": "Trac\\xE9 4287",
    d: "M675.519,1383.061a.646.646,0,0,1,.619.67v6.792a.646.646,0,0,1-.619.67H666a.646.646,0,0,1-.619-.67v-6.792a.646.646,0,0,1,.619-.67h9.514m0-1.843H666a2.491,2.491,0,0,0-2.463,2.514v6.792a2.491,2.491,0,0,0,2.463,2.514h9.514a2.491,2.491,0,0,0,2.463-2.514v-6.792a2.491,2.491,0,0,0-2.463-2.514Z",
    transform: "translate(-663.542 -1381.218)",
    fill: "#1f3c88"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M80.308,284.967V262.408H52.876V249.032l23.918-55.886h18.25v56.793h9.409v12.469H95.045v22.558ZM66.025,249.939H80.308v-39.9Z",
    transform: "translate(550.277 152.148)",
    fill: "#385b89",
    stroke: "#2a4467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M187.451,285.365q-8.05,0-13.319-3.4a21.06,21.06,0,0,1-7.935-9.409,33.808,33.808,0,0,1-2.664-13.83v-40.7a36.186,36.186,0,0,1,2.55-14.113,20.349,20.349,0,0,1,7.822-9.466q5.271-3.4,13.546-3.4t13.546,3.4a20.346,20.346,0,0,1,7.822,9.466,36.187,36.187,0,0,1,2.551,14.113v40.7a33.844,33.844,0,0,1-2.664,13.83,21.07,21.07,0,0,1-7.935,9.409Q195.5,285.365,187.451,285.365Zm0-13.489a6.236,6.236,0,0,0,5.215-2.154,11.71,11.71,0,0,0,2.267-5.214,33.019,33.019,0,0,0,.566-6.008V218.257a38.946,38.946,0,0,0-.51-6.291,11.288,11.288,0,0,0-2.21-5.272q-1.7-2.152-5.328-2.154t-5.328,2.154a11.287,11.287,0,0,0-2.21,5.272,38.891,38.891,0,0,0-.511,6.291V258.5a30.028,30.028,0,0,0,.624,6.008,12.192,12.192,0,0,0,2.324,5.214A6.1,6.1,0,0,0,187.451,271.876Z",
    transform: "translate(499.469 153.111)",
    fill: "#385b89",
    stroke: "#2a4467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M297.849,284.967V262.408H270.417V249.032l23.918-55.886h18.251v56.793h9.409v12.469h-9.409v22.558Zm-14.284-35.028h14.284v-39.9Z",
    transform: "translate(450.398 152.148)",
    fill: "#385b89",
    stroke: "#2a4467",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M92.945,284.967V262.408H65.513V249.032l23.918-55.886h18.25v56.793h9.409v12.469h-9.409v22.558ZM78.662,249.939H92.945v-39.9Z",
    transform: "translate(544.471 152.148)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M200.087,285.365q-8.05,0-13.319-3.4a21.06,21.06,0,0,1-7.935-9.409,33.808,33.808,0,0,1-2.664-13.83v-40.7a36.186,36.186,0,0,1,2.551-14.113,20.348,20.348,0,0,1,7.822-9.466q5.271-3.4,13.546-3.4t13.546,3.4a20.348,20.348,0,0,1,7.822,9.466,36.186,36.186,0,0,1,2.551,14.113v40.7a33.844,33.844,0,0,1-2.664,13.83,21.07,21.07,0,0,1-7.935,9.409Q208.136,285.365,200.087,285.365Zm0-13.489a6.236,6.236,0,0,0,5.215-2.154,11.7,11.7,0,0,0,2.267-5.214,32.979,32.979,0,0,0,.567-6.008V218.257a38.9,38.9,0,0,0-.51-6.291,11.288,11.288,0,0,0-2.211-5.272q-1.7-2.152-5.328-2.154t-5.328,2.154a11.287,11.287,0,0,0-2.21,5.272,38.836,38.836,0,0,0-.511,6.291V258.5a29.983,29.983,0,0,0,.624,6.008,12.186,12.186,0,0,0,2.324,5.214A6.1,6.1,0,0,0,200.087,271.876Z",
    transform: "translate(493.67 153.111)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M310.485,284.967V262.408H283.053V249.032l23.918-55.886h18.25v56.793h9.409v12.469h-9.409v22.558ZM296.2,249.939h14.284v-39.9Z",
    transform: "translate(444.596 152.148)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.0725f8d8db77eb0b821b75164344e0d4.svg";
export { ForwardRef as ReactComponent };